module.exports = __webpack_public_path__ + "static/media/parts-bg.c83564e8.png";